export const environment = {
  production: true,
  name: 'staging',
  server: 'https://wallet-service.env.edvisor.io/api/',
  authDomain: 'dev-5eaxaoj6xctpe1q3.us.auth0.com',
  authAudience: 'https://test.edwallet.com',
  authClientId: 'YcHDBvOvyU270Wsb9bS6R2uKP5GwJtFB',
  sentryDsn: '',
  devCycleSdkKey: 'dvc_client_97a24a6b_82eb_430f_92e3_771727619e51_6321841',
  userpilotToken: 'STG-NX-0d27bba8', // default staging token
};
